<template>
  <div id="page-user-view">
    <vs-alert
      color="danger"
      title="User Not Found"
      :active.sync="user_not_found"
    >
      <span>User record with id: {{ $route.params.id }} not found. </span>
      <span>
        <span>Check </span
        ><router-link to="/users" class="text-inherit underline"
          >All Users</router-link
        >
      </span>
    </vs-alert>

    <div id="user-data" v-if="user_data">
      <vx-card title="Account" class="mb-base">
        <!-- Avatar -->
        <div class="vx-row">
          <!-- Avatar Col -->
          <div class="vx-col" id="avatar-col">
            <div class="img-container mb-4">
              <img :src="user_data.avatar | media" class="rounded w-full" />
            </div>
          </div>

          <!-- Information - Col 1 -->
          <div class="vx-col flex-1" id="account-info-col-1">
            <table>
              <tr>
                <td class="font-semibold">Username</td>
                <td>{{ user_data.username }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Name</td>
                <td>{{ user_data.firstname }} {{ user_data.lastname }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Email</td>
                <td>{{ user_data.email }}</td>
              </tr>
            </table>
          </div>
          <!-- /Information - Col 1 -->

          <!-- Information - Col 2 -->
          <div class="vx-col flex-1" id="account-info-col-2">
            <table>
              <tr>
                <td class="font-semibold">Role</td>
                <td>{{ user_data.role | capitalize }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Created At</td>
                <td>{{ user_data.createdAt | date }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Updated At</td>
                <td>{{ user_data.updatedAt | date }}</td>
              </tr>
            </table>
          </div>
          <!-- /Information - Col 2 -->
          <div class="vx-col w-full flex" id="account-manage-buttons">
            <vs-button
              icon-pack="feather"
              icon="icon-edit"
              class="mr-4"
              color="success"
              :to="{
                name: 'user-edit',
                params: { id: $route.params.id },
              }"
              >Edit</vs-button
            >
            <vs-button
              type="border"
              color="danger"
              icon-pack="feather"
              icon="icon-trash"
              @click="confirmDeleteRecord"
              >Delete</vs-button
            >
          </div>
        </div>
      </vx-card>

      <div class="vx-row">
        <div class="vx-col lg:w-1/2 w-full">
          <vx-card title="Personal Information" class="mb-base">
            <table>
              <tr>
                <td class="font-semibold">Birth Date</td>
                <td>{{ user_data.dateOfBirth | date }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Phone</td>
                <td>{{ user_data.phone }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Gender</td>
                <td>{{ user_data.gender | capitalize }}</td>
              </tr>
            </table>
          </vx-card>
        </div>

        <div class="vx-col lg:w-1/2 w-full">
          <vx-card title="Job Information" class="mb-base">
            <table>
              <tr>
                <td class="font-semibold">Position</td>
                <td>{{ user_data.position }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Directorate</td>
                <td>{{ user_data.directorate }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Level</td>
                <td>{{ user_data.level }}</td>
              </tr>
            </table>
          </vx-card>
        </div>
      </div>

      <vx-card>
        <vs-progress
          indeterminate
          color="primary"
          class="mb-5"
          v-if="loading"
        ></vs-progress>
        <!-- List of Progress -->
        <vs-table
          max-items="1"
          stripe
          state
          :sst="true"
          :data="progressData"
          @sort="handleSort"
          @search="handleSearch"
        >
          <template slot="thead">
            <vs-th width="30px">No</vs-th>
            <vs-th sort-key="schedule">Title</vs-th>
            <vs-th sort-key="sessions">Session</vs-th>
            <vs-th sort-key="percentage" width="200px">Percentage</vs-th>
            <vs-th sort-key="finishAt">Finish</vs-th>
            <vs-th>Action</vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr v-for="(tr, indextr) in data" :key="indextr">
              <vs-td>
                {{ indextr + 1 + (pagination.page - 1) * 20 }}
              </vs-td>
              <vs-td>
                {{
                  data[indextr].schedule
                    ? data[indextr].schedule.label
                    : 'Schedule Deleted'
                }}
              </vs-td>
              <vs-td> {{ data[indextr].sessions.length }} Session </vs-td>
              <vs-td>
                <p>{{ data[indextr].percentage * 100 }} %</p>
                <vs-progress
                  :percent="data[indextr].percentage * 100"
                  color="primary"
                  class="shadow-md"
                />
              </vs-td>
              <vs-td>
                {{ data[indextr].finishAt | date }}
              </vs-td>
              <vs-td>
                <vs-button
                  :to="`/progress/${data[indextr].id}/detail`"
                  color="primary"
                  icon-pack="feather"
                  icon="icon-eye"
                  :disabled="!data[indextr].schedule ? true : false"
                />
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
        <vs-pagination
          class="mt-5"
          :total="pagination.total"
          v-model="pagination.page"
          @change="handleChangePage"
        ></vs-pagination>
      </vx-card>
    </div>
  </div>
</template>

<script>
import debounce from 'lodash/debounce'
export default {
  data() {
    return {
      id: null,
      user_data: null,
      user_not_found: false,

      selected: {
        status: false,
        type: '',
      },

      keyword: '',
      sort: '',

      pagination: {
        page: 1,
        total: 1,
      },

      loading: false,
      activePrompt: false,
    }
  },

  methods: {
    isDebounceFetch: debounce(function(val) {
      this.keyword = val
      this.fetch()
    }, 500),

    async fetch(val) {
      val ? val : 1
      this.loading = true

      let keyword = this.keyword
      let sort = this.sort
      let id = this.id

      let payload = {
        sort: sort,
        page: val,
        perPage: 20,
        filter: {
          user: id,
        },
        select: 'percentage schedule finishAt',
      }

      if (keyword) {
        payload.filter = {
          keyword: { $regex: `.*${keyword}*.`, $options: 'i' },
          user: id,
        }
      }

      payload.filter = JSON.stringify(payload.filter)

      let res = await this.$store.dispatch('progress/findAll', payload)

      if (res.status === 200) {
        this.pagination.total = Math.ceil(res.data.paging.count / 20)
        this.pagination.page = res.data.paging.page
      }

      this.loading = false
    },

    async getUser() {
      let id = this.id
      let res = await this.$store.dispatch('users/findOne', id)

      if (res.status === 200) {
        this.user_data = res.data
      } else {
        this.user_not_found = true
      }
    },

    handleChangePage: debounce(function(val) {
      this.fetch(val)
    }, 300),

    handleSort(val, active) {
      active = active === 'asc' ? '' : '-'
      this.sort = active + val
      this.fetch()
    },

    handleSearch(val) {
      this.isDebounceFetch(val)
    },

    confirmDeleteRecord() {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm Delete',
        text: `You are about to delete "${this.user_data.username}"`,
        accept: this.deleteRecord,
        acceptText: 'Delete',
      })
    },

    async deleteRecord() {
      let res = await this.$store.dispatch('users/deleteOne', this.user_data.id)
      if (res.status === 200) {
        this.$router.push('/users')
        this.showDeleteSuccess()
      }
    },

    showDeleteSuccess() {
      this.$vs.notify({
        color: 'success',
        title: 'User Deleted',
        text: 'The selected user was successfully deleted',
      })
    },
  },

  computed: {
    progressData() {
      return this.$store.state.progress.progress
    },
  },

  async created() {
    this.id = this.$route.params.id

    this.fetch()
    this.getUser()
  },
}
</script>

<style lang="scss">
#avatar-col {
  width: 10rem;
}

#page-user-view {
  table {
    td {
      vertical-align: top;
      min-width: 140px;
      padding-bottom: 0.8rem;
      word-break: break-all;
    }

    &:not(.permissions-table) {
      td {
        @media screen and (max-width: 370px) {
          display: block;
        }
      }
    }
  }
}

@media screen and (min-width: 1201px) and (max-width: 1211px),
  only screen and (min-width: 636px) and (max-width: 991px) {
  #account-info-col-1 {
    width: calc(100% - 12rem) !important;
  }
}
</style>
